import { friendlyErrorMessage } from '@/core/lib/dbError'

import { extractAvgsOnGate, type ExtractionAvgsForm } from '@/core/api/extraction'
import { ok, technical, type Result } from '@/core/lib/result'

export type AvgsForm = ExtractionAvgsForm

export async function extractAvgs(path: string | Blob): Promise<Result<AvgsForm>> {
  try {
    return ok(await extractAvgsOnGate(path))
  } catch (error) {
    return technical(friendlyErrorMessage(error, 'AVGS-Erkennung fehlgeschlagen.'))
  }
}
